import type CalendarCloudSetting from '../store/schema/CalendarCloudSetting';
import { getStore } from '../store/store';
import type { ObservableMap } from 'mobx';

/**
 * Gets the value for the enableOnlineMeetingsByDefault cloud setting
 */
export default function getCalendarCloudSettings(): ObservableMap<string, CalendarCloudSetting> {
    return getStore().settings;
}
